import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewChecked, OnDestroy {
  current_lang = 'it';

  @select(['geopos', 'list'])
  geopos_list$: Observable<any>;
  geopos_list;

  geopos_url = {
    'Cimbri': 'cimbri',
    'Friulani in Veneto': 'friuli',
    'Italiani in Slovenia': 'italiani-in-slovenia',
    'Ladini del Comelico': 'ladini',
    'Sloveni in Italia': 'sloveni-in-italia',
    'Friulani in Friuli Venezia Giulia': 'friuli-fvg',
  };

  subscriptions: Subscription[] = [];

  constructor(private titleService: Title,
              private translate: TranslateService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.titleService.setTitle('PRIMIS');
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.geopos_list$.subscribe((list) => {
        this.geopos_list = [...list];
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  ngAfterViewChecked(): void {
    this.titleService.setTitle('PRIMIS');
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
  }
}
